module.exports = __webpack_public_path__ + "img/co2.f2ade6f6.svg";